/* eslint-disable */ 
import { URL } from '../../../config'
import { getRequest } from '../../../utils/functions/httpRequest'

export const getRankingELBySeasonWeek = function (seasonId,weekNo) 
{
    const endpoint = `/${seasonId}/${weekNo}/rankingEventLinksBySeasonWeek`
    const rankingURL = `${URL.ranking}${endpoint}` 
    return getRequest(rankingURL)
} 
 


// WEBPACK FOOTER //
// ./src/components/pages/api/getRankingELBySeasonWeek.js